var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLajmerimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15.208,
    viewBox: "0 0 20 15.208",
    fill: "#121212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5744",
    "data-name": "Group 5744",
    transform: "translate(-426 -450.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8272",
    "data-name": "Path 8272",
    d: "M18,12h0a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H19A1,1,0,0,0,18,12Z",
    transform: "translate(424 446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8273",
    "data-name": "Path 8273",
    d: "M16.59,16.82a.966.966,0,0,0,.2,1.37c.53.39,1.09.81,1.62,1.21a.978.978,0,0,0,1.38-.2c0-.01.01-.01.01-.02a.978.978,0,0,0-.2-1.38c-.53-.4-1.09-.82-1.61-1.21a.993.993,0,0,0-1.39.21A.035.035,0,0,1,16.59,16.82Z",
    transform: "translate(424 446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8274",
    "data-name": "Path 8274",
    d: "M19.81,4.81c0-.01-.01-.01-.01-.02a.98.98,0,0,0-1.38-.2c-.53.4-1.1.82-1.62,1.22a.979.979,0,0,0-.19,1.38c0,.01.01.01.01.02a.979.979,0,0,0,1.38.2c.53-.39,1.09-.82,1.62-1.22A.994.994,0,0,0,19.81,4.81Z",
    transform: "translate(424 446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8275",
    "data-name": "Path 8275",
    d: "M8,9H4a2.006,2.006,0,0,0-2,2v2a2.006,2.006,0,0,0,2,2H5v3a1,1,0,0,0,1,1H6a1,1,0,0,0,1-1V15H8l5,3V6Z",
    transform: "translate(424 446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8276",
    "data-name": "Path 8276",
    d: "M15.5,12A4.48,4.48,0,0,0,14,8.65v6.69A4.442,4.442,0,0,0,15.5,12Z",
    transform: "translate(424 446)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLajmerimeIcon);
export default __webpack_public_path__ + "static/media/lajmerime_icon.5304872777a6594236dac99f5c51a519.svg";
export { ForwardRef as ReactComponent };